import { useDispatch, useSelector } from "react-redux";
import { showSnackbar, hideSnackbar } from "./Snackbar.slice";

export const useSnackbar = () => {
  const dispatch = useDispatch();
  const { open, message, severity, autoHideDuration, anchorOrigin } = useSelector(
    (state) => state.snackbar
  );

  const showSuccess = (message, options = {}) => {
    dispatch(
      showSnackbar({
        message,
        severity: "success",
        ...options,
      })
    );
  };

  const showError = (message, options = {}) => {
    dispatch(
      showSnackbar({
        message,
        severity: "error",
        ...options,
      })
    );
  };

  const showWarning = (message, options = {}) => {
    dispatch(
      showSnackbar({
        message,
        severity: "warning",
        ...options,
      })
    );
  };

  const showInfo = (message, options = {}) => {
    dispatch(
      showSnackbar({
        message,
        severity: "info",
        ...options,
      })
    );
  };

  const showCustom = (message, severity = "info", options = {}) => {
    dispatch(
      showSnackbar({
        message,
        severity,
        ...options,
      })
    );
  };

  const hide = () => {
    dispatch(hideSnackbar());
  };

  return {
    // Estado del snackbar
    open,
    message,
    severity,
    autoHideDuration,
    anchorOrigin,
    
    // Métodos para mostrar diferentes tipos de snackbar
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showCustom,
    
    // Método para ocultar
    hide,
  };
};
